document.addEventListener('DOMContentLoaded', () => {
    // Счетчик символов для textarea
    document.querySelectorAll('.placing-order__textarea').forEach((textarea) => {
        const wrapper = textarea.closest('.placing-order__textarea-wrapper')
        if (wrapper) {
            const counter = wrapper.querySelector('.placing-order__textarea-max-container span:first-child')
            if (counter) {
                textarea.addEventListener('input', function () {
                    counter.textContent = this.value.length
                })
            }
        }
    })
})
